import { type EntityType, entity } from "@/admin/entity.ts";
import { type DeleteModalProps, DeleteModal } from "@/components/modal/DeleteModal.tsx";

interface ADeleteButtonProps extends Omit<DeleteModalProps, "modalAction" | "children"> {
    deleteFn: () => Promise<unknown>;
    entityType: EntityType;
}

/** A simple delete button with a confirmation modal for entities. */
export function ADeleteButton({ deleteFn, entityType, ...props }: ADeleteButtonProps) {
    const { name } = entity[entityType];
    return (
        <DeleteModal
            modalAction={async () => {
                await deleteFn();
            }}
            inTable
            {...props}
        >
            Are you sure you want to delete this {name}?
        </DeleteModal>
    );
}
